'use strict';

angular.module('adelementAdminApp')
    .controller('UserAdvertiserMappingController', function ($scope, $state, UserAdvertiserMapping, ParseLinks) {

        $scope.userAdvertiserMappings = [];
        $scope.predicate = 'id';
        $scope.reverse = true;
        $scope.page = 1;
        $scope.loadAll = function() {
            UserAdvertiserMapping.query({page: $scope.page - 1, size: 20, sort: [$scope.predicate + ',' + ($scope.reverse ? 'asc' : 'desc'), 'id']}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.totalItems = headers('X-Total-Count');
                $scope.userAdvertiserMappings = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();


        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.userAdvertiserMapping = {
                userId: null,
                advertiserId: null,
                id: null
            };
        };
    });
